module.exports = __webpack_public_path__ + "img/gif.20e2ff15.png";